import { DataTableColumnHeader } from "@/components/ui";
import { type LeadSourceMapping } from "@/lib/types";
import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<LeadSourceMapping>();

export function getLeadSourceMappingTableColumns() {
  return [
    columnHelper.accessor("key", {
      id: "Outside Key",
      enableHiding: false,
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: (cell) => (
        <span className="font-mono">{cell.getValue<string>()}</span>
      ),
    }),
    columnHelper.accessor((mapping) => mapping.target.displayItemLabel, {
      id: "Item",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
    }),
    columnHelper.accessor((mapping) => mapping.target.displayAttributeLabel, {
      id: "Attribute",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
    }),
    // No actions column; clicks open the edit slideover per app standards
  ] as ColumnDef<LeadSourceMapping>[];
}
